<template>
    <div>
        <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="time">
                <el-input v-model="pgData.txtkey"  placeholder="项目名称" clearable></el-input>
            </el-form-item>
            <el-form-item slot="title">
                <el-input v-model="pgData.xmxzqh"  placeholder="项目所属地区" clearable></el-input>
            </el-form-item>
            <template slot="btn">
                <btn-common :row="addBtnObj" style="margin-left:10px"></btn-common>
            </template>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="项目名称" prop="proname" min-width="180" fixed="left"></el-table-column>
            <el-table-column label="项目编号" prop="procode" min-width="120"></el-table-column>
            <el-table-column label="法人" prop="faren" width="140"></el-table-column>
            <el-table-column label="项目行业" prop="prohyflname" width="220"></el-table-column>
            <el-table-column label="项目所属地区" prop="procitydisname" width="180"></el-table-column>
            <el-table-column label="项目地址" prop="proaddress" width="200"></el-table-column>
            <el-table-column label="操作" min-width="180" fixed="right">
                <template slot-scope="scope">
                    <btn-list 
                        :row="scope.row"
                        @reload="reloadHandler"
                        style="float:left"
                        :config="BTN_CONF">
                    </btn-list>
                    <btn-common :row="scope.row" @reload="reloadHandler"></btn-common>
                    <btn-elec-agree style="float:left;margin-left:10px" :listType="listTypeVal" :row="scope.row"></btn-elec-agree>
                    
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('mngUrl')}/Zbdl/Project/get_list.json`">
        </my-pagination>
        
       
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

import BTN_CONF from './config/btn-list'
import BtnElecAgree from '@views/bidding/elec-agreement/components/btn'
import BtnCommon from './common/btn' //项目助理 补充统一代码按钮 添加项目按钮





export default {
    mixins: [LIST_PAGE_MIXIN],
    components: {BtnElecAgree,BtnCommon},
    data() {
        return{
            pgData: {
                txtkey:'',
                xmxzqh: '',
                sortname:'procode'
            },

            BTN_CONF,
            listTypeVal:'jsgcxm',

            addBtnObj:{val:'add'}

        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        
    },
    created() {
       setSession('isRevision',0)
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
